// import { api_common } from '@/api/interface/index'
import { commonShare } from './share'
// import storage from '@/common/uilt/storage';
import fnIcon from '@/common/website/website-icon';
import store from '@/store/index'
export default async function publicGetShareInfo(to, shareInfo, shareName,type,productObj) {
    //如果没有传值，默认值为空对象
    let shareId = store.state.share.shareId;
    if(!shareName){
        shareName = "shareId"
    }
    if (!shareInfo) {
        shareInfo = {};
    }
    let groupInfo = store.state.loginInfo.mechanismInfo;
    let userInfo = store.state.loginInfo.userInfo;
    let uid, is_agent, inviteUser
    if (userInfo) {
        uid = userInfo.uid;//用户id
        is_agent = userInfo.is_agent;//0不是代理1是代理
        inviteUser = userInfo.inviteUser//邀请人信息
    }
    let shareTitle, //分享标题  
        shareUrl,// 分享链接
        shareImg,//分享图标
        shareDesc, //分享描述
        productType= {
            goods_type: '',
            title: '',
            goods_id: ''
        }; //
    //判断如果是自定义分享信息 type 1使用机构名称加参数
    shareTitle = groupInfo.name;// 分享标题
    let domain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    shareUrl = domain + to.path + '?'; // 分享链接
    // shareUrl = groupInfo.domain + to.path + '?'; // 分享链接
    shareImg = groupInfo.logo; // 分享图标
    shareDesc = groupInfo.slogan;// 分享描述
    if (groupInfo.logo) {
        fnIcon(groupInfo.logo)//网站图标
    }
    if (shareInfo.type == 1) {
        shareTitle = groupInfo.name + shareInfo.title1;
    } else {
        if (shareInfo.title1) {
            shareTitle = shareInfo.title1;
        }
        if (shareInfo.title2) {
            shareDesc = shareInfo.title2;
        }
        if (shareInfo.title2 == 'gift') {
            shareDesc = '';
        }
        if (shareInfo.imgSrc) {
            shareImg = shareInfo.imgSrc;
        }
    }
    // 如果存在 productObj，则合并其属性
    if (productObj) {
        // 合并属性，优先使用 productObj 中的值
        productType.title = productObj.title || productType.title;
        productType.goods_type = productObj.goods_type || productType.goods_type;
        productType.goods_id = productObj.goods_id || productType.goods_id;
    }
    if (to.query) {
        delete to.query.code;
        delete to.query.state;
        delete to.query.appid;
        for (let key in to.query) {
            if (key !== 'shareId' && key !== 'secretKey') {
                shareUrl += key + '=' + to.query[key] + '&';
            }
        }
    }
    if (to.meta?.type && !productObj) {
        productType={
            goods_type: to.meta.type || ''
        }
    }
    if (is_agent == 1) {
        // 当前用户是代理
        shareUrl += shareName + '=' + uid + '&';
    } else {
        if (shareId > 0 && shareId != uid) {
            // 如果页面链接上携带了share_id的值
            shareUrl += shareName + '=' + shareId + '&';
        } else {
            //  当前用户不是代理
            if (groupInfo.invite_type == 1) {
                // 1官方
                shareUrl += shareName + '=' + '&';
            } else if (groupInfo.invite_type == 2) {
                //2上级
                shareUrl += shareName + '=' + inviteUser + '&';
            }
        }
    }
    // 加参数判断是否点击分享进的页面  productType 是张璐做统计访问的详情说要传产品类型和id , visitorTitle是刘飞让直接传产品名称来统计  个人认为不合理但是必须做
    shareUrl += 'isFirst=1'
   await commonShare(shareTitle, shareUrl, shareImg, shareDesc,type,productType)
    
}